var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-05
 * @brief EHP 메시지 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState } from "../../../../recoil/menuState";
import { langState } from '../../../../recoil/langState';
// utils
import clog from "../../../../utils/logUtils";
import * as CONST from "../../../../utils/Const";
import * as CUTIL from "../../../../utils/commUtils";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
/**
 * @brief EHP 메시지 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function CheckMsgList(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //props
    const isMobile = props.isMobile;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //화면 이동
    const navigate = useNavigate();
    //
    const [messageList, setMessageList] = useState([]);
    const defaultPageInfo = { "size": 10, "totalElements": 0, "totalPages": 0, "number": 0, "psize": 10 };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    const [codeParam, setCodeParam] = useState("");
    let appPath = "";
    appPath = 'page=' + pageInfo.number + '&size=' + pageInfo.size;
    if (codeParam.length > 0) {
        appPath = appPath + "&menuCode=" + codeParam;
    }
    const [listReload, setListReload] = useState(false);
    const [errorList, setErrorList] = useState([]);
    //{menuCode, menuName, errList : {}}
    //[{"field":"menuName","msg":"필수 항목입니다."}]
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/message/alarmmessages`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree + appPath + listReload
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0) {
            setRecoilIsLoadingBox(false);
            navigate(ERR_URL);
        }
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN CHECK MESSAGE LIST : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setListReload(false); // list reload
                setMessageList(retData.body);
                setPageInfo(Object.assign(Object.assign({}, retData.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT })); //5, 10
            }
        }
    }, [selTree, retData]);
    //////////////////
    function handleListReload(val, page) {
        if (page > -1)
            handleCurPage([page]);
        setListReload(val);
    }
    useEffect(() => {
        setParentPopWin("pop-message-add", React.createElement(PopupCheckMessageInsert, { htmlHeader: React.createElement("h1", null, "e-Health Checker \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
    }, [listReload]);
    function onClickInsertCheckMessage(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-add");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "796");
        setParentPopWin("pop-message-add", React.createElement(PopupCheckMessageInsert, { htmlHeader: React.createElement("h1", null, "e-Health Checker \uBA54\uC138\uC9C0"), listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickViewCheckMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        setParentPopWin("pop-message", React.createElement(PopupCheckMessageView, { htmlHeader: React.createElement("h1", null, "e-Health Checker \uBA54\uC138\uC9C0"), checkMessage: message, listReload: listReload, setListReload: handleListReload, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickDeleteCheckMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-delete");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "200");
        setParentPopWin("pop-delete", React.createElement(PopupCheckMessageDelete, { htmlHeader: React.createElement("h1", null, "\uC0AD\uC81C"), checkMessage: message, listReload: listReload, setListReload: handleListReload }));
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype" },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "e-Health Checker \uBA54\uC138\uC9C0")),
            React.createElement("div", { className: "tbl__top mb-16" },
                React.createElement("div", { className: "right" },
                    React.createElement("button", { type: "button", className: "bg-gray js-open", "data-pop": "pop-message-add", 
                        /* onClick={(e) => onClickInsertCheckMessage(e)} */
                        disabled // 사용 시 제거 및 onClick 주석 해체
                        : true },
                        React.createElement("span", null, "\uCD94\uAC00")))),
            React.createElement("div", { className: "tbl-list message-list hcal-140" },
                React.createElement("table", { summary: "\uC774\uB984,\uC885\uB958,\uBA54\uC138\uC9C0,\uC694\uC57D,\uC5B8\uC5B4,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C e-Health Checker \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "e-Health Checker \uBA54\uC138\uC9C0 \uB9AC\uC2A4\uD2B8"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "12%" } }),
                        React.createElement("col", { style: { "width": "10%" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "" } }),
                        React.createElement("col", { style: { "width": "190px" } }),
                        React.createElement("col", { style: { "width": "6%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC774\uB984"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC885\uB958"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uBA54\uC138\uC9C0"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC694\uC57D"),
                            React.createElement("th", { scope: "col", className: "txt-left" }, "\uC5B8\uC5B4"),
                            React.createElement("th", { scope: "col" }, "\uC0AD\uC81C"))),
                    React.createElement("tbody", null, messageList.map((msg, idx) => (React.createElement("tr", { key: `msg_tr_${idx.toString()}` },
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewCheckMessage(e, msg) },
                            React.createElement("strong", null, msg.name)),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewCheckMessage(e, msg) },
                            React.createElement("strong", null, msg.type)),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewCheckMessage(e, msg) }, msg.descriptionKorean),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewCheckMessage(e, msg) }, msg.summaryKorean),
                        React.createElement("td", { className: "txt-left js-open", "data-pop": "pop-message", onClick: (e) => onClickViewCheckMessage(e, msg) },
                            React.createElement("ul", { className: "messagelang" },
                                React.createElement("li", { className: (!CUTIL.isnull(msg.descriptionKorean) && msg.descriptionKorean.length > 0) ? "on" : "" }, "\uD55C\uAD6D\uC5B4"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.descriptionEnglish) && msg.descriptionEnglish.length > 0) ? "on" : "" }, "English"),
                                React.createElement("li", { className: (!CUTIL.isnull(msg.descriptionChinese) && msg.descriptionChinese.length > 0) ? "on" : "" }, "\u4E2D\u6587"))),
                        React.createElement("td", null,
                            React.createElement("button", { type: "button", className: "btn btn-delete-gr js-open", "data-pop": "pop-delete", 
                                /* onClick={(e) => onClickDeleteCheckMessage(e, msg)} */
                                disabled // 사용 시 제거 및 onClick 주석 해체
                                : true },
                                React.createElement("span", { className: "hide" }, "\uD56D\uBAA9 \uC0AD\uC81C"))))))))))));
}
;
export default CheckMsgList;
function PopupCheckMessageInsert(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    const defaultVal = {
        "name": "",
        "type": "",
        "descriptionKorean": "",
        "descriptionEnglish": "",
        "descriptionChinese": "",
        "summaryKorean": "",
        "summaryEnglish": "",
        "summaryChinese": ""
    };
    const [checkMessage, setCheckMessage] = useState(defaultVal);
    useEffect(() => {
        setCheckMessage(defaultVal);
    }, [listReload]);
    function callbackSetCheckDescriptionKor(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionKorean: val }));
    }
    function callbackSetCheckDescriptionEng(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionEnglish: val }));
    }
    function callbackSetCheckDescriptionCha(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionChinese: val }));
    }
    function callbackSetCheckSummaryKor(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryKorean: val }));
    }
    function callbackSetCheckSummaryEng(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryEnglish: val }));
    }
    function callbackSetCheckSummaryCha(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryChinese: val }));
    }
    const [errorList, setErrorList] = useState([]);
    function onClickDoSaveCheckMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doSaveCheckMessage({
                "type": checkMessage.type,
                "name": checkMessage.name,
                "description": checkMessage.descriptionKorean,
                "summary": checkMessage.summaryKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN CHECK MSG : KOR INSERT : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doSaveCheckMessage({
                    "type": checkMessage.type,
                    "name": checkMessage.name,
                    "description": checkMessage.descriptionEnglish,
                    "summary": checkMessage.summaryEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN CHECK MSG : ENG INSERT : " + JSON.stringify(data.body));
                    }
                    else { //english
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doSaveCheckMessage({
                        "type": checkMessage.type,
                        "name": checkMessage.name,
                        "description": checkMessage.descriptionChinese,
                        "summary": checkMessage.summaryChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN CHECK MSG : CHA INSERT : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            //errList.push({"field":});
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        if (doCnt === succCnt) {
                            setParentListReload(true, 0);
                            CUTIL.jsclose_Popup("pop-message-add");
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doSaveCheckMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/message/alarmmessage`,
                appQuery: {
                    "type": cmsg.type,
                    "name": cmsg.name,
                    "description": cmsg.description,
                    "summary": cmsg.summary,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    //alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-message-add");
        setParentListReload(true, 0);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("name")).length > 0) ? "input-error" : "", value: checkMessage.name, onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { name: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("name") && (idx === 0)).map((err) => err.msg)))),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC885\uB958"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("type")).length > 0) ? "input-error" : "", value: checkMessage.type, onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { type: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("type") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionKorean")).length > 0) ? "input-error" : "", value: checkMessage.descriptionKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionKor), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionEnglish")).length > 0) ? "input-error" : "", value: checkMessage.descriptionEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionEng), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionChinese")).length > 0) ? "input-error" : "", value: checkMessage.descriptionChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionCha), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC694\uC57D")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryKorean")).length > 0) ? "input-error" : "", value: checkMessage.summaryKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryKor), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryEnglish")).length > 0) ? "input-error" : "", value: checkMessage.summaryEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryEng), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryChinese")).length > 0) ? "input-error" : "", value: checkMessage.summaryChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryCha), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryChinese")).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoSaveCheckMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupCheckMessageView(props) {
    const setParentPopWin = props.setPopWin;
    const [checkMessage, setCheckMessage] = useState(null);
    //const onClickUpdateCheckMessage = props.onClickUpdateCheckMessage;
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const [updateCount, setUpdateCount] = useState(0);
    useEffect(() => {
        setCheckMessage(props.checkMessage);
        setUpdateCount(0);
    }, [props.checkMessage]);
    function onClickUpdateCheckMessage(e, message) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message-edit");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message-edit", React.createElement(PopupCheckMessageUpdate, { htmlHeader: React.createElement("h1", null, "e-Health Checker \uBA54\uC138\uC9C0"), checkMessage: message, listReload: listReload, setListReload: props.setListReload, updateCount: updateCount, setUpdateCount: setUpdateCount, setPopWin: props.setPopWin }));
        CUTIL.jsopen_Popup(e);
    }
    function onClickCancel(e) {
        //setParentListReload(true);
        CUTIL.jsclose_Popup("pop-message");
        setParentPopWin("pop-message", null);
    }
    return (React.createElement(React.Fragment, null,
        (checkMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: checkMessage.name, disabled: true }))),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC885\uB958"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", value: checkMessage.type, disabled: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.descriptionKorean) ? "" : checkMessage.descriptionKorean, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.descriptionEnglish) ? "" : checkMessage.descriptionEnglish, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.descriptionChinese) ? "" : checkMessage.descriptionChinese, readOnly: true })))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC694\uC57D")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.summaryKorean) ? "" : checkMessage.summaryKorean, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.summaryEnglish) ? "" : checkMessage.summaryEnglish, readOnly: true }))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { value: CUTIL.isnull(checkMessage.summaryChinese) ? "" : checkMessage.summaryChinese, readOnly: true }))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-open btn-close", "data-pop": "pop-message-edit", onClick: (e) => onClickUpdateCheckMessage(e, checkMessage) },
                React.createElement("span", null, "\uC218\uC815")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function PopupCheckMessageUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const listReload = props.listReload;
    const setParentListReload = props.setListReload;
    //
    const updateCount = props.updateCount;
    const setParentUpdateCount = props.setUpdateCount;
    //
    const setParentPopWin = props.setPopWin;
    //
    const [checkMessage, setCheckMessage] = useState(null);
    useEffect(() => {
        setCheckMessage(props.checkMessage);
    }, [updateCount, props.checkMessage]);
    function callbackSetCheckDescriptionKor(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionKorean: val }));
    }
    function callbackSetCheckDescriptionEng(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionEnglish: val }));
    }
    function callbackSetCheckDescriptionCha(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionChinese: val }));
    }
    function callbackSetCheckSummaryKor(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryKorean: val }));
    }
    function callbackSetCheckSummaryEng(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryEnglish: val }));
    }
    function callbackSetCheckSummaryCha(val) {
        setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryChinese: val }));
    }
    const [errorList, setErrorList] = useState([]);
    function onClickDoUpdateCheckMessage(e) {
        return __awaiter(this, void 0, void 0, function* () {
            const errList = [];
            var doCnt = 0;
            var doneCnt = 0;
            var succCnt = 0;
            let data = null;
            setRecoilIsLoadingBox(true);
            doCnt++;
            data = yield doUpdateCheckMessage({
                "type": checkMessage.type,
                "name": checkMessage.name,
                "description": checkMessage.descriptionKorean,
                "summary": checkMessage.summaryKorean,
                "language": CONST.STR_APILANG_KOR
            });
            if (data) {
                doneCnt++;
                if (data.codeNum == CONST.API_200) {
                    succCnt++;
                    clog("IN HTTP MSG : KOR UPDATE : " + JSON.stringify(data.body));
                }
                else { // api if korean
                    // need error handle
                    data.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_KOR, "msg": elist.msg })));
                }
                CUTIL.sleep(500);
                doCnt++;
                let edata = yield doUpdateCheckMessage({
                    "type": checkMessage.type,
                    "name": checkMessage.name,
                    "description": checkMessage.descriptionEnglish,
                    "summary": checkMessage.summaryEnglish,
                    "language": CONST.STR_APILANG_ENG
                });
                if (edata) {
                    doneCnt++;
                    if (edata.codeNum == CONST.API_200) {
                        succCnt++;
                        clog("IN HTTP MSG : ENG UPDATE : " + JSON.stringify(data.body));
                    }
                    else { //english
                        edata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_ENG, "msg": elist.msg })));
                    }
                    CUTIL.sleep(500);
                    doCnt++;
                    let cdata = yield doUpdateCheckMessage({
                        "type": checkMessage.type,
                        "name": checkMessage.name,
                        "description": checkMessage.descriptionChinese,
                        "summary": checkMessage.summaryChinese,
                        "language": CONST.STR_APILANG_CHA
                    });
                    if (cdata) {
                        doneCnt++;
                        if (cdata.codeNum == CONST.API_200) {
                            succCnt++;
                            clog("IN HTTP MSG : CHA UPDATE : " + JSON.stringify(data.body));
                        }
                        else { //chinese
                            cdata.body.errorList.map((elist) => (errList.push({ "field": elist.field + CONST.STR_APILANG_CHA, "msg": elist.msg })));
                        }
                    }
                    if (doneCnt === 3) { // KOR/ENG/CHA
                        setErrorList(errList);
                        setParentListReload(true, -1);
                        setParentPopWin("pop-message", React.createElement(PopupCheckMessageView, { htmlHeader: React.createElement("h1", null, "e-Health Checker \uBA54\uC138\uC9C0"), checkMessage: checkMessage, listReload: listReload, setListReload: props.setListReload, setPopWin: props.setPopWin }));
                        if (doCnt === succCnt) {
                            CUTIL.jsclose_Popup("pop-message-edit");
                            var popupVal = e.target.getAttribute("data-pop");
                            if (CUTIL.isnull(popupVal))
                                e.target.setAttribute("data-pop", "pop-message");
                            CUTIL.jsopen_Popup(e);
                        }
                        else {
                        }
                        doneCnt = 0;
                        setRecoilIsLoadingBox(false);
                    }
                }
            }
        });
    }
    function doUpdateCheckMessage(cmsg) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/message/alarmmessage`,
                appQuery: {
                    "type": cmsg.type,
                    "name": cmsg.name,
                    "description": cmsg.description,
                    "summary": cmsg.summary,
                    "language": cmsg.language
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum !== CONST.API_200) {
                    alert(`ERROR : ${cmsg.language} : ` + JSON.stringify(data.body.errorList));
                }
            }
            return data;
        });
    }
    function onClickCancel(e) {
        var popupVal = e.target.getAttribute("data-pop");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-pop", "pop-message");
        popupVal = e.target.getAttribute("data-ds-height");
        if (CUTIL.isnull(popupVal))
            e.target.setAttribute("data-ds-height", "773");
        CUTIL.jsclose_Popup("pop-message-edit");
        setParentPopWin("pop-message-edit", null);
        CUTIL.jsopen_Popup(e);
        setErrorList([]);
        setParentUpdateCount(updateCount + 1);
    }
    return (React.createElement(React.Fragment, null,
        (checkMessage) && React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("name")).length > 0) ? "input-error" : "", value: checkMessage.name, 
                            //onChange={(e) => setCheckMessage({ ...checkMessage, name: e.target.value })}
                            readOnly: true, disabled: true }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("name") && (idx === 0)).map((err) => err.msg)))),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC885\uB958"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("input", { type: "text", className: (errorList.filter(err => err.field.includes("type")).length > 0) ? "input-error" : "", value: checkMessage.type, onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { type: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter((err, idx) => err.field.includes("type") && (idx === 0)).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBA54\uC138\uC9C0")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionKorean")).length > 0) ? "input-error" : "", value: checkMessage.descriptionKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionKor), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionEnglish")).length > 0) ? "input-error" : "", value: checkMessage.descriptionEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionEng), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "descriptionChinese")).length > 0) ? "input-error" : "", value: checkMessage.descriptionChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckDescriptionCha), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { descriptionChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "descriptionChinese")).map((err) => err.msg))))),
            React.createElement("ul", { className: "form__input" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC694\uC57D")),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uD55C\uAD6D\uC5B4"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryKorean")).length > 0) ? "input-error" : "", value: checkMessage.summaryKorean, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryKor), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryKorean: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryKorean")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC601\uBB38 (English)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryEnglish")).length > 0) ? "input-error" : "", value: checkMessage.summaryEnglish, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryEng), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryEnglish: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryEnglish")).map((err) => err.msg)))),
                React.createElement("li", { className: "sub-input" },
                    React.createElement("p", { className: "tit" }, "\uC911\uBB38 (\u4E2D\u6587)"),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("textarea", { placeholder: "", className: (errorList.filter(err => (err.field === "summaryChinese")).length > 0) ? "input-error" : "", value: checkMessage.summaryChinese, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCheckSummaryCha), onChange: (e) => setCheckMessage(Object.assign(Object.assign({}, checkMessage), { summaryChinese: e.target.value })) }),
                        React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "summaryChinese")).map((err) => err.msg)))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateCheckMessage(e) },
                React.createElement("span", null, "\uC644\uB8CC")))));
}
function PopupCheckMessageDelete(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props  
    const setParentListReload = props.setListReload;
    const [checkMessage, setCheckMessage] = useState(null);
    useEffect(() => {
        setCheckMessage(props.checkMessage);
    }, [props.checkMessage]);
    function onClickDoDeleteCheckMessage(e, message) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/message/alarmmessage`,
                appQuery: {
                    "name": message.name,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    clog("IN COMPANY : onClickDoSaveCompany : " + JSON.stringify(data.body));
                    CUTIL.jsclose_Popup("pop-delete");
                    setParentListReload(true, 0);
                }
                else { // api if
                    // need error handle
                    alert("ERROR : " + JSON.stringify(data.body.errorList));
                }
            }
        });
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-delete");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uD574\uB2F9 \uC5D0\uB7EC\uBA54\uC138\uC9C0\uB97C \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close btn-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, "\uCDE8\uC18C")),
            React.createElement("button", { type: "button", className: "", onClick: (e) => onClickDoDeleteCheckMessage(e, checkMessage) },
                React.createElement("span", null, "\uD655\uC778")))));
}
